import { getParentTabsCount } from './getParentTabsCount';

export const getZoneType = (
	pathLength: number,
	...[getItem, id]: Parameters<typeof getParentTabsCount>
): 'Section' | 'Column' | 'Control' => {
	const tabsCount = getParentTabsCount(getItem, id);
	const mod = (pathLength - tabsCount) % 3;

	switch (mod) {
		case 0:
			return 'Control'; // 3/3=0
		case 1:
			return 'Section'; // 1/3=1
		case 2:
			return 'Column'; // 2/3=2
	}
};
